export const environment = {
  production: true,
  configFile: 'environment.json'
};
